// extracted by mini-css-extract-plugin
export default {"brand-kind-select":"brand-kind-select--HdSY7"};